module.exports = __webpack_public_path__ + "static/img/avater.d959de91.png";